import {
  ActionEnum,
  CustomReportResponse,
  DashboardTypes,
  Environment,
  GetFlowchartCampaignsV2Query,
  GetPublishedCampaigns_v2Query,
  StatementType,
  UserIsAuthorizedMultiQuery,
  UserIsAuthorizedQuery,
  client,
  countryEnum,
  flowchartCampaignWithType,
  publishedCampaignsResponse_v2,
  publishedType,
  queryInput,
  subCampaignResponse,
} from 'API';
import { API } from 'aws-amplify';
import { useClientContext } from 'context/ClientContext';
import { useDataQuery } from 'customHooks/useDataQuery';
import {
  useCampaignId,
  useCampaignPeriodId,
  useChildCampaignId,
  useClientCode,
  useSubCampaignId,
} from 'customHooks/useParameters';
import { useActiveSubCampaign } from 'customHooks/useSubcampaignList';
import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  getFlowchartCampaignsV2,
  getPublishedCampaigns_v2,
  userIsAuthorized,
  userIsAuthorizedMulti,
} from '../graphql/queries';
import APIContext from './APIContext';
import AuthContext from './AuthContext';
import { usePrepKPIQuery } from 'customHooks/prepKPIquery';
import { useGetSummaryStatus } from 'customHooks/useGettSummaryStatus';
import { useGetCustomReports } from 'components/NewPortal/Main/OrganisationReport';

type SubCampaignObject = {
  [key: number]: {
    campaignId: string;
    subCampaignId: string;
    published: publishedType;
    __typename: string;
  };
};

export type ACdetails =
  | (flowchartCampaignWithType & { subcampaign: SubCampaignObject } & { authorized: boolean } & {
      childCampaigns?: ACdetails[];
    } & { parentReference?: number } & { campaignPeriods?: CustomReportsDetails[] })
  | undefined;
interface IFilter {
  code: string;
  country: string;
}
interface mediaSourceData {
  media_source: string;
  actual_cost: number;
}
interface yearWeekData {
  year_week: string;
  actual_cost: number;
}

type CampaignContextProps = {
  campaignList: Array<ACdetails> | undefined;
  // setCampaignList: (args: Array<ACdetails>) => void;
  activeCampaign: ACdetails;
  // setActiveCampaign: (args: ACdetails) => void;
  // dashType: string,
  setDashType: (arg: DashboardTypes) => void;
  dashType: DashboardTypes | null;
  TVStationSelector: string;
  setTVStationSelector: (args: string) => void;
  RadioStationSelector: string;
  setRadioStationSelector: (args: string) => void;
  clientFilterList: IFilter[];
  setClientFilterList: (args: IFilter[]) => void;
  reducedClientList: Array<ACdetails> | undefined;
  filterCampaignsPerClientCode: (args: IFilter[]) => void;
  actualBudget: number;
  numberOfCampaigns: number;
  campaignActualBudget: number;
  costPerMedia: Array<mediaSourceData> | undefined;
  costPerWeek: Array<yearWeekData> | undefined;
  currentYearBudget: number | undefined;
  recommendedYearBudget: number | undefined;
  approvedBudget: number | undefined;
  startDateFilter: string;
  setStartDateFilter: (args: string) => void;
  endDateFilter: string;
  setEndDateFilter: (args: string) => void;
  order: string;
  setOrder: (args: string) => void;
  fetchedPortalData: Array<IData>;
  permanentCampaignList: Array<ACdetails> | null;
  setPermanentCampaignList: (args: Array<ACdetails>) => void;
  navigationCampaignList: Array<ACdetails> | undefined;
  availableCampaigns: Array<ACdetails> | undefined;
  checkDashPublished: (
    subCampaignO:
      | {
          campaignId: string;
          subCampaignId: string;
          published: publishedType;
          __typename: string;
        }
      | undefined,
    dash: DashboardTypes,
  ) => boolean;
  activeSubCampaign: subCampaignResponse | undefined;
  actualBudgetPublished: number | undefined;
  subCampaignList: subCampaignResponse[];
  updatePermanentCampaignList: (args: string, arg2: string) => void;
  /*   handlePublishSummary: () => void;
    campaignOverFlowqueryStatus: string; */

  overflowKPIquery: queryInput | undefined;
  overFlowqueryStatus: string;
  setOverflowKPIquery: React.Dispatch<React.SetStateAction<queryInput | undefined>>;
  setClientSearchTerm: (args: string) => void;
  excludeAlwaysOn: boolean;
  setExcludeAlwaysOn: (args: boolean) => void;
  canDoInsourceAndOnInsourcePortal: boolean;
  childCampaignIndex: number;
  setChildCampaignIndex: (args: number) => void;
  customReportsList: CustomReportsDetails[] | undefined;
  setCustomReportsList: React.Dispatch<React.SetStateAction<CustomReportsDetails[] | undefined>>;
  clientSearchTerm: string;
};
export enum status {
  UNBRIEFED = 'UNBRIEFED',
  BRIEFED = 'BRIEFED',
  UNPUBLISHED = 'UNPUBLISHED',
  PARTPUBLISHED = 'PARTPUBLISHED',
  PUBLISHED = 'PUBLISHED',
}

export type CustomReportsDetails =
  | (CustomReportResponse & { authorized: boolean } & { subcampaign: SubCampaignObject } & { isActive?: boolean })
  | undefined;

const { REACT_APP_AGENCY } = process.env;
export const CampaignContext = createContext<CampaignContextProps | undefined>(undefined);
interface IData {
  actual_cost: number;
  campaign_id: number;
  client_code: string;
  country: string;
  media_source: string;
  year_week: string;
  end_Date: string;
  start_Date: string;
}

export const CampaignContextProvider = (props: any) => {
  const { user, isAuthorized } = useContext(AuthContext);
  const [orgId] = useClientCode();
  const [campaignId, , deleteCampaignID] = useCampaignId();
  const [subCampaignId] = useSubCampaignId();
  const [clientSearchTerm, setClientSearchTerm] = useState<string>('');
  const { userCanDoInsource } = useClientContext();
  // const [campaignList, setCampaignList] = useState<Array<ACdetails>>();
  // const [activeCampaign, setActiveCampaign] = useState<ACdetails>();
  const [permanentCampaignList, setPermanentCampaignList] = useState<Array<ACdetails> | null>(null);
  const { getEnvironment } = useContext(APIContext);
  const [fetchReports] = useGetCustomReports();

  const [dashType, setDashType] = useState(null as DashboardTypes | null);
  const [excludeAlwaysOn, setExcludeAlwaysOn] = useState<boolean>(false);
  const [TVStationSelector, setTVStationSelector] = useState('All stations');
  const [RadioStationSelector, setRadioStationSelector] = useState('All stations');
  const [clientFilterList, setClientFilterList] = useState<IFilter[]>([]);
  const [reducedClientList, setReducedClientList] = useState<Array<ACdetails>>();
  const [fetchedPortalData, setFetchedPortalData] = useState<Array<IData>>([]);
  const [childCampaignIndex, setChildCampaignIndex] = useState<number>(0);
  const [childCamp, setChildCamp, deleteChildCampID] = useChildCampaignId();
  const [campaignPeriod, setCampaignPeriod, deleteCampaignPeriod] = useCampaignPeriodId();
  const [, setSearchParams] = useSearchParams();
  const [order, setOrder] = useState<string>('desc');
  useEffect(() => {
    dashType === DashboardTypes.FLOWCHART ? setOrder('asc') : setOrder('desc');
  }, [dashType]);

  //create date value in format YYYY-MM-DD for 1st of January this year
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentYearString = currentYear.toString();
  const nextYearString = (currentYear + 1).toString();
  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

  const [startDateFilter, setStartDateFilter] = useState<string>(
    getEnvironment === Environment.STAGING
      ? '2022-01-01'
      : orgId === 'PD01#SE'
        ? `2022-01-01`
        : // : `${currentYearString}-01-01`,
          `${sixMonthsAgo.getFullYear()}-${('0' + (sixMonthsAgo.getMonth() + 1)).slice(-2)}-15`,
    // getEnvironment === Environment.STAGING ? '2023-01-01' : `2024-01-01`,
  );
  // const [startDateFilter, setStartDateFilter] = useState<string>(`2023-01-01`);
  const [endDateFilter, setEndDateFilter] = useState<string>(`${nextYearString}-12-31`);

  const prevOrgIdRef = useRef<string | null>(null);
  useEffect(() => {
    // Skip on initial mount, only reset when orgId actually changes
    if (prevOrgIdRef.current === null) {
      prevOrgIdRef.current = orgId;
      return;
    }
    if (prevOrgIdRef.current === orgId) {
      return;
    }
    prevOrgIdRef.current = orgId;

    // Reset all filters when organization changes
    if (getEnvironment === Environment.STAGING) {
      setStartDateFilter('2022-01-01');
    } else if (orgId === 'PD01#SE') {
      setStartDateFilter('2022-01-01');
    } else {
      const resetSixMonthsAgo = new Date();
      resetSixMonthsAgo.setMonth(resetSixMonthsAgo.getMonth() - 6);
      setStartDateFilter(
        `${resetSixMonthsAgo.getFullYear()}-${('0' + (resetSixMonthsAgo.getMonth() + 1)).slice(-2)}-15`,
      );
    }
    const resetNextYear = new Date().getFullYear() + 1;
    setEndDateFilter(`${resetNextYear}-12-31`);
    setClientFilterList([]);
    setClientSearchTerm('');
    setExcludeAlwaysOn(false);
    setOrder('desc');
  }, [orgId, getEnvironment]);
  // const [activeSubCampaign, subCampaignList] = useActiveSubCampaign(dashType);
  const [overflowKPIquery, setOverflowKPIquery] = useState<queryInput>();

  const [customReportsList, setCustomReportsList] = useState<CustomReportsDetails[] | undefined>(undefined);
  const [allCampaignPeriods, setAllCampaignPeriods] = useState<CustomReportsDetails[] | undefined>(undefined);

  //TODO
  const [overFlowdata, overFlowqueryStatus, overFlowerror, overFlowqueryId, overFlowoutputLocation] = useDataQuery({
    query: overflowKPIquery,
    querySource: 'OVERFLOW KPI' /* , publishedOutputLocation: publishedOutputLocation  */,
  });

  // console.log('overFlowdata', overflowKPIquery);

  useEffect(() => {
    if (overFlowdata) {
      setFetchedPortalData(overFlowdata as Array<IData>);
    } else {
      setFetchedPortalData([]);
    }
  }, [overFlowdata]);

  useEffect(() => {
    if (overFlowerror) {
      setFetchedPortalData([
        {
          actual_cost: -1,
          campaign_id: -1,
          client_code: 'error',
          country: 'error',
          media_source: 'error',
          year_week: 'error',
          start_Date: 'error',
          end_Date: 'error',
        },
      ]);
    }
  }, [overFlowerror]);

  useEffect(() => {
    async function fetchCampaignList(orgId: string) {
      // setPermanentCampaignList([]);
      setPermanentCampaignList(null);
      const date18MonthsAgo = new Date();
      date18MonthsAgo.setMonth(date18MonthsAgo.getMonth() - 18);
      const startDate15MonthsAgo =
        date18MonthsAgo.getFullYear() + '-' + ('0' + (date18MonthsAgo.getMonth() + 1)).slice(-2) + '-' + '15';
      //TODO COOP
      const date6MonthsAgo = new Date();
      date6MonthsAgo.setMonth(date6MonthsAgo.getMonth() - 6);
      const startDate6MonthsAgo =
        date6MonthsAgo.getFullYear() + '-' + ('0' + (date6MonthsAgo.getMonth() + 1)).slice(-2) + '-' + '15';
      //TODO VATENFALL
      const date36MonthsAgo = new Date();
      date36MonthsAgo.setMonth(date36MonthsAgo.getMonth() - 36);
      const startDate36MonthsAgo =
        date36MonthsAgo.getFullYear() + '-' + ('0' + (date36MonthsAgo.getMonth() + 1)).slice(-2) + '-' + '15';

      //TODO MCDONALDS
      const date14MonthsAgo = new Date();
      date14MonthsAgo.setMonth(date14MonthsAgo.getMonth() - 14);
      const startDate14MonthsAgo =
        date14MonthsAgo.getFullYear() + '-' + ('0' + (date14MonthsAgo.getMonth() + 1)).slice(-2) + '-' + '15';

      let responseList;
      try {
        const responseListTemp = (await API.graphql({
          query: getFlowchartCampaignsV2,
          variables: {
            Organization_id: orgId,
            from:
              orgId === 'CODK#DK' 
                ? startDate6MonthsAgo
                : orgId === 'SIL2#DK' || orgId === 'PD01#SE' || orgId === 'ORKL#DK'
                  ? startDate36MonthsAgo
                  : orgId === 'MCD1#DK' || orgId === 'NUUD#DK'
                    ? startDate14MonthsAgo
                    : startDate15MonthsAgo,
          },
          authMode: 'AMAZON_COGNITO_USER_POOLS',
        })) as { data: GetFlowchartCampaignsV2Query; errors: any };
        responseList = responseListTemp;
      } catch (error) {
        console.log('error', error);
        alert('Error fetching campaigns. Please contact support at dk.support@annalect.com');
        return [];
      }
      const fetchIsInsource = async (): Promise<boolean> => {
        try {
          const response = (await API.graphql({
            query: userIsAuthorizedMulti,
            variables: {
              Organization_id: orgId,
              Environment: getEnvironment,
              Resource: 'INSOURCE', // Write publish instead of queries,
              Service: 'OMDPortal',
              StatementType: StatementType.Access,
              Action: ActionEnum.WRITE,
            },
            authMode: 'AMAZON_COGNITO_USER_POOLS',
          })) as { data: UserIsAuthorizedMultiQuery };

          const data = response.data.userIsAuthorizedMulti;
          if (data) {
            const isIt = data.some((e) => e?.Authorized === true);
            return isIt;
          } else {
            return false;
          }
        } catch (e) {
          console.log('ERROR IN FETCH USER IS AUTHORIZED MULTI2', e);
          return false; // Ensure a boolean is always returned
        }
      };

      const response = responseList.data.getFlowchartCampaignsV2;
      const isInsource = await fetchIsInsource();
      const tempBVOD = response?.map((element) => {
        let updatedDashboardTypes = element?.dashboardType
          .filter((e) => /* (e as string) !== 'BVOD' && */ (e as string) !== 'empty')
          .concat(DashboardTypes.OVERWRITE);

        if (element?.dashboardType.includes(DashboardTypes.DIGITAL) && isInsource) {
          updatedDashboardTypes = updatedDashboardTypes?.concat(DashboardTypes.INSOURCE_DATA);
        }

        return {
          ...element,
          dashboardType: updatedDashboardTypes,
        };
      });
      return tempBVOD as Array<flowchartCampaignWithType>;
    }

    async function fetchPublishedCampaignsFromCampaignList(campaignCodesList: string[]) {
      // console.log('campaignCode', campaignCodesList);
      // Batch requests to avoid AppSync "Transformation too large" error on large campaign lists.
      const CHUNK_SIZE = 300;
      try {
        const chunks: string[][] = [];
        for (let i = 0; i < campaignCodesList.length; i += CHUNK_SIZE) {
          chunks.push(campaignCodesList.slice(i, i + CHUNK_SIZE));
        }

        const responses = await Promise.all(
          chunks.map(
            (chunk) =>
              API.graphql({
                query: getPublishedCampaigns_v2,
                variables: {
                  campaigns: chunk,
                },
                authMode: 'AMAZON_COGNITO_USER_POOLS',
              }) as Promise<{ data: GetPublishedCampaigns_v2Query }>,
          ),
        );

        const resultList = responses.flatMap((res) => res.data.getPublishedCampaigns_v2 ?? []);

        return resultList as Array<publishedCampaignsResponse_v2>;
      } catch (e) {
        console.log(`errorPublishedCampaigns ${e}`, e);
      }
    }

    async function fetchIsUserAuthorizedToSeeUnpublishedCampaigns(
      uniqArray: { ClientCode: string; ClientCountry: string }[],
    ) {
      try {
        const response = (await API.graphql({
          query: userIsAuthorized,
          variables: {
            Clients: uniqArray,
            Resource: 'UnPublishedCampaigns',
            Environment: getEnvironment,
            Action: ActionEnum.READ,
          },
          authMode: 'AMAZON_COGNITO_USER_POOLS',
        })) as { data: UserIsAuthorizedQuery };
        const pero = response.data.userIsAuthorized;
        // Create

        return pero as Array<{ Client: { ClientCode: string; ClientCountry: string }; Authorized: boolean }>;
      } catch (e) {
        console.log('ERROR IS IN USER_IS_AUTHORIZED', e);
      }
    }

    if (orgId !== 'none' && isAuthorized) {
      fetchCampaignList(orgId)
        .then((res) => {
          const campaignList = res;

          if (campaignList !== null && campaignList !== undefined) {
            // const campaignCodesList = campaignsDetails.map(element => element.campaignId?.toString())
            // const campaignCodesList = campaignList.map((element) => element.campaignId?.toString());
            const campaignCodesList = campaignList
              .flatMap((element) => {
                if (element.childCampaigns && element.childCampaigns.length > 0) {
                  return element.childCampaigns
                    .map((childCampaign) => childCampaign?.campaignId?.toString())
                    .concat(element.campaignId?.toString());
                } else {
                  return element.campaignId?.toString();
                }
              })
              .filter((id): id is string => id !== undefined);
            fetchPublishedCampaignsFromCampaignList(campaignCodesList).then((res) => {
              const resultList = res;
              // console.log('12 3 resultList', resultList);
              const updatedCampaignDetails4 = campaignList.map((element) => ({
                ...element,
                subcampaign: resultList
                  ?.filter((el) => el?.campaignId === element.campaignId?.toString())
                  .reduce((acc: any, curr: any) => {
                    acc[curr['subCampaignId'] as keyof typeof acc] = {
                      ...curr,
                    };
                    return acc;
                  }, {}),
                childCampaigns: element.childCampaigns?.map((childCampaign) => {
                  const childCampaignId = childCampaign?.campaignId;
                  const subCampaigns = resultList?.filter((el) => el?.campaignId === childCampaignId?.toString());
                  return {
                    ...childCampaign,
                    subcampaign: subCampaigns?.reduce((acc: any, curr: any) => {
                      acc[curr['subCampaignId'] as keyof typeof acc] = {
                        ...curr, //TODO
                      };
                      return acc;
                    }, {}),
                  };
                }),
              }));

              const onlyCodeandCountry = updatedCampaignDetails4.map((e) => {
                return {
                  ClientCode: e.ClientCode,
                  ClientCountry: e.ClientCountry,
                };
              });

              const uniqArray = [
                ...new Map(
                  onlyCodeandCountry.map((v) => [JSON.stringify([v.ClientCode, v.ClientCountry]), v]),
                ).values(),
              ];

              fetchIsUserAuthorizedToSeeUnpublishedCampaigns(uniqArray).then((res) => {
                const checkAuthorization = (campaign: ACdetails) => {
                  const foundObject = res?.find(
                    (peroEl) =>
                      JSON.stringify(peroEl?.Client) ===
                      JSON.stringify({
                        ClientCode: campaign?.ClientCode,
                        ClientCountry: campaign?.ClientCountry,
                        __typename: 'Clients',
                      }),
                  );
                  return foundObject?.Authorized as boolean;
                };

                const finalResult = updatedCampaignDetails4.map((el) => {
                  const authorized = checkAuthorization(el as ACdetails);

                  const updatedChildCampaigns = el.childCampaigns?.map((childCampaign) => {
                    const childAuthorized = checkAuthorization(childCampaign as ACdetails);
                    return { ...childCampaign, authorized: childAuthorized };
                  });

                  return { ...el, authorized, childCampaigns: updatedChildCampaigns };
                });

                fetchReports(orgId).then((res) => {
                  console.log('CUSTOM REPORTS', res);
                  if (res) {
                    const customReportsList = res;
                    const customReportsCodeList = customReportsList.map((element) =>
                      element.CustomReportID?.toString(),
                    );
                    //TODO FETCH oVO MOZDA TREBA ZAMiJENITI S SUMMARY PUBLISHED
                    fetchPublishedCampaignsFromCampaignList(customReportsCodeList).then((res) => {
                      const resultList = res;
                      const campaignsListWithPublishedStatus = customReportsList.map((element) => ({
                        ...element,
                        subcampaign: resultList
                          ?.filter((el) => el?.campaignId === element.CustomReportID?.toString())
                          .reduce((acc: any, curr: any) => {
                            acc[curr['subCampaignId'] as keyof typeof acc] = {
                              ...curr,
                            };
                            return acc;
                          }, {}),
                      }));

                      const onlyCodeandCountry = campaignsListWithPublishedStatus.map((e) => {
                        return {
                          ClientCode: e.Client?.Code as string,
                          ClientCountry: e.Client?.Country as string,
                        };
                      });
                      const uniqArray = [
                        ...new Map(
                          onlyCodeandCountry.map((v) => [JSON.stringify([v.ClientCode, v.ClientCountry]), v]),
                        ).values(),
                      ];
                      fetchIsUserAuthorizedToSeeUnpublishedCampaigns(uniqArray).then((res) => {
                        const checkAuthorization = (report: CustomReportResponse) => {
                          const foundObject = res?.find(
                            (peroEl) =>
                              JSON.stringify(peroEl?.Client) ===
                              JSON.stringify({
                                ClientCode: report.Client?.Code as string,
                                ClientCountry: report.Client?.Country as string,
                                __typename: 'Clients',
                              }),
                          );
                          return foundObject?.Authorized as boolean;
                        };
                        const listWithAuthorizedAndPublished = campaignsListWithPublishedStatus.map((el) => {
                          const authorized = checkAuthorization(el);
                          return { ...el, authorized, isActive: false };
                        });
                        const customReportsList = listWithAuthorizedAndPublished
                          .filter((el) => el.CampaignID === null)
                          .filter((f) => {
                            if (f.authorized) {
                              return true;
                            } else {
                              return f.subcampaign[-1]?.published.DIGITAL === true;
                            }
                          });
                        const campaignPeriodList = listWithAuthorizedAndPublished.filter((el) => el.CampaignID);
                        setCustomReportsList(customReportsList as CustomReportsDetails[]);
                        setAllCampaignPeriods(campaignPeriodList as CustomReportsDetails[]);

                        // console.log('campaignPeriodList', campaignPeriodList);
                        const finalResultWithCampaignPeriods = finalResult.map((el) => {
                          const campaignPeriods = campaignPeriodList.filter(
                            (campaignPeriod) => campaignPeriod.CampaignID === el.campaignId,
                          );

                          // Build updated child campaigns with their periods and propagate
                          // published status from child campaignPeriods up to child subcampaign[-1]
                          const childCampaigns = el.childCampaigns?.map((childCampaign) => {
                            const childCampaignPeriods =
                              campaignPeriodList.filter(
                                (campaignPeriod) => campaignPeriod.CampaignID === childCampaign.campaignId,
                              ) ?? [];

                            const childMinusOne = childCampaign.subcampaign[-1]?.published;
                            const updatedChildMinusOne = childMinusOne
                              ? Object.entries(childMinusOne).reduce(
                                  (acc, [key, value]) => {
                                    if (value === false) {
                                      // propagate from campaignPeriods
                                      const fromPeriod = childCampaignPeriods.some(
                                        (period) => period.subcampaign[-1]?.published[key] === true,
                                      );
                                      // propagate from real subcampaign keys (e.g. 31149 with TV:true)
                                      const fromSubcampaigns = Object.entries(childCampaign.subcampaign)
                                        .filter(([k]) => k !== '-1')
                                        .some(([, sub]) => (sub as any)?.published?.[key] === true);
                                      acc[key] = fromPeriod || fromSubcampaigns ? true : value;
                                    } else {
                                      acc[key] = value;
                                    }
                                    return acc;
                                  },
                                  {} as typeof childMinusOne,
                                )
                              : childMinusOne;

                            return {
                              ...childCampaign,
                              campaignPeriods: childCampaignPeriods,
                              subcampaign: {
                                ...childCampaign.subcampaign,
                                [-1]: {
                                  ...childCampaign.subcampaign[-1],
                                  published: updatedChildMinusOne,
                                  // rawPublished preserves the backend value before period propagation;
                                  // used by PublishContext and dropdowns to distinguish direct publish
                                  // from propagated-from-period publish state.
                                  rawPublished: childMinusOne,
                                },
                              },
                            };
                          });

                          // Umbrella subcampaign[-1]: true if any direct period OR any child period is published
                          const campaignsminusOneSubcampaign = el.subcampaign[-1].published;
                          const updatedCampaignsMinusOneSubcampaign = Object.entries(
                            campaignsminusOneSubcampaign,
                          ).reduce(
                            (acc, [key, value]) => {
                              if (value === false) {
                                const directPeriodPublished = campaignPeriods.some(
                                  (period) => period.subcampaign[-1]?.published[key] === true,
                                );
                                const childPeriodPublished = (childCampaigns ?? []).some(
                                  (child) => child.subcampaign[-1]?.published[key] === true,
                                );
                                acc[key] = directPeriodPublished || childPeriodPublished ? true : value;
                              } else {
                                acc[key] = value;
                              }
                              return acc;
                            },
                            {} as typeof campaignsminusOneSubcampaign,
                          );

                          return {
                            ...el,
                            campaignPeriods,
                            childCampaigns,
                            subcampaign: {
                              ...el.subcampaign,
                              [-1]: { ...el.subcampaign[-1], published: updatedCampaignsMinusOneSubcampaign },
                            },
                          };
                        });

                        // console.log('This is the permanentCampaignList ', finalResultWithCampaignPeriods);
                        setPermanentCampaignList(finalResultWithCampaignPeriods as Array<ACdetails>);
                      });
                    });
                  } else {
                    setPermanentCampaignList(finalResult as Array<ACdetails>);
                    // console.log('NO CUSTOM REPORTS');
                    setCustomReportsList(undefined);
                    setAllCampaignPeriods(undefined);
                  }
                });
              });
            });
          } else {
            // setPermanentCampaignList([]);
            setPermanentCampaignList(null);
          }
        })
        .catch((err) => {
          // setPermanentCampaignList([]);
          setCustomReportsList(undefined);
          setAllCampaignPeriods(undefined);
          setPermanentCampaignList(null);
        });
    } else {
      setPermanentCampaignList(null);
    }
  }, [getEnvironment, orgId, isAuthorized]);

  useEffect(() => {
    console.log('permanentCampaignList', permanentCampaignList);
  }, [permanentCampaignList]);

  const checkDashPublished = (
    subCampaignO:
      | {
          campaignId: string;
          subCampaignId: string;
          published: publishedType;
          __typename: string;
        }
      | undefined,
    dash: DashboardTypes,
  ) => {
    // if (subCampaignO === undefined) return false;

    if (dash === 'DIGITAL') {
      return subCampaignO?.published.DIGITAL === true;
    }
    if (dash === 'TV') {
      return subCampaignO?.published.TV === true;
    }
    if (dash === 'RADIO') {
      return subCampaignO?.published.RADIO === true;
    }
    if (dash === 'PRINT') {
      return subCampaignO?.published.PRINT === true;
    }
    if (dash === 'OOH') {
      return subCampaignO?.published.OOH === true;
    }
    if (dash === 'CINEMA') {
      return subCampaignO?.published.CINEMA === true;
    }
    if (dash === 'BVOD') {
      return subCampaignO?.published.BVOD === true;
    }
    if (dash === 'SEARCH') {
      return subCampaignO?.published.SEARCH === true;
    }
    return false;
  };

  const isHomeDashboard =
    dashType === DashboardTypes.HOME ||
    dashType === DashboardTypes.FLOWCHART; /* || dashType === DashboardTypes.INSOURCE_DATA */
  const canDoInsourceAndOnInsourcePortal = userCanDoInsource && dashType === DashboardTypes.INSOURCE_DATA;

  const availableCampaigns = useMemo(() => {
    // Build a set of campaign IDs that are already nested as child campaigns under an umbrella.
    // These should never appear as standalone top-level entries in the dropdown.
    const childCampaignIds = new Set(
      permanentCampaignList?.flatMap((el) => el?.childCampaigns?.map((c) => c?.campaignId) ?? []) ?? [],
    );

    return permanentCampaignList !== null && isHomeDashboard
      ? permanentCampaignList?.flatMap((el) => {
          if (el === undefined) {
            return [];
          } else {
            return el;
          }
        })
      : permanentCampaignList?.flatMap((el) => {
          if (el === undefined) {
            return [];
          }
          // Skip campaigns that are already nested under an umbrella — they must be accessed
          // via the umbrella's child dropdown, not as standalone top-level entries.
          if (childCampaignIds.has(el.campaignId)) {
            return [];
          }
          //check if el is dashboard type array
          if (el.dashboardType.some((dt) => (dt === 'BVOD' ? dashType === DashboardTypes.TV : dt === dashType))) {
            //if yes, check if authorized is true
            if (el.authorized === true || canDoInsourceAndOnInsourcePortal) {
              return el;
            }

            if (
              dashType === 'DIGITAL' ||
              dashType === 'PRINT' ||
              dashType === 'OOH' ||
              dashType === 'CINEMA' ||
              dashType === 'INSOURCE_DATA' ||
              dashType === 'SEARCH'
            ) {
              //  check if the subcampaign[-1].published[dashType] is true and return element
              const subcampaigns = el.subcampaign[-1];
              if (subcampaigns === undefined) {
                return [];
              }
              const chechDoesAnyofChildCampaignsHsDshTypePublished = (childCampaigns: ACdetails[]) => {
                const childCampaignsPublished = childCampaigns.map((childCampaign) => {
                  const childSubCampaigns = childCampaign?.subcampaign[-1];
                  return checkDashPublished(childSubCampaigns, dashType);
                });
                return childCampaignsPublished.includes(true);
              };
              if (
                subcampaigns.published[dashType === 'INSOURCE_DATA' ? 'DIGITAL' : dashType] === true ||
                (el.childCampaigns && chechDoesAnyofChildCampaignsHsDshTypePublished(el.childCampaigns))
              ) {
                return el;
              }
              if (el.campaignPeriods && el.campaignPeriods.length > 0) {
                const isSomeoneOfTheCampaignPeriodsPublished = el.campaignPeriods.some((el) => {
                  const subcampaigns = el?.subcampaign[-1];
                  if (subcampaigns === undefined) {
                    return false;
                  }
                  return checkDashPublished(subcampaigns, dashType);
                });
                if (isSomeoneOfTheCampaignPeriodsPublished) {
                  return el;
                }
              }
              return [];
            }

            if (dashType === 'TV' || dashType === 'RADIO') {
              //  check if the subcampaign[-1].published[dashType] is true and return element
              // const subcampaigns = el.subcampaign[Number(subCampaignId)];
              const minusOneSubcampaign = el.subcampaign[-1];
              if (minusOneSubcampaign) {
                if (dashType === 'TV' && minusOneSubcampaign.published.BVOD === true) {
                  return el;
                }
              }
              for (const [key, value] of Object.entries(el.subcampaign)) {
                if (value.published[dashType] === true) {
                  return el;
                }
              } //TODO maybe check custom reports here too
              /*      if (subcampaigns === undefined) {
               return [];
             }
             if (subcampaigns.published[dashType] === true) {
               return el;
             } */
              return [];
            }
            return [];
          }
          return [];
        });
  }, [permanentCampaignList, isHomeDashboard, dashType, canDoInsourceAndOnInsourcePortal]);

  const campaignList = useMemo(() => {
    return dashType === null
      ? undefined
      : availableCampaigns === undefined
        ? undefined
        : dashType === DashboardTypes.HOME
          ? availableCampaigns
          : availableCampaigns
              ?.filter((element) =>
                clientFilterList.length > 0
                  ? clientFilterList.some(
                      (element2) =>
                        element2?.code === element?.ClientCode && element2?.country === element?.ClientCountry,
                    )
                  : !clientFilterList.some(
                      (element2) =>
                        element2?.code === element?.ClientCode && element2?.country === element?.ClientCountry,
                    ),
              )
              .filter((el) => {
                const startDate = new Date(el?.startDate as string);
                const endDate = new Date(el?.startDate as string);
                const startDateFilterDate = new Date(startDateFilter);
                const endDateFilterDate = new Date(endDateFilter);
                const dashboardType = el?.dashboardType as Array<DashboardTypes>;
                return startDate >= startDateFilterDate && endDate <= endDateFilterDate;
              })
              .filter((el) => {
                // console.log("this is the fetchedCampaignList stuff", el)
                if (excludeAlwaysOn) {
                  // return campaigns whose difference between start and end date is less than 180 days
                  const startDate = new Date(el?.startDate as string);
                  const endDate = new Date(el?.endDate as string);
                  const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
                  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                  return diffDays < 180;
                } else {
                  return el;
                }
              })
              .sort((a, b) => {
                if (a?.startDate && b?.startDate) {
                  if (order === 'asc') {
                    return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
                  } else {
                    return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
                  }
                } else {
                  return 0;
                }
              })
              .filter((el) =>
                dashType === DashboardTypes.FLOWCHART
                  ? el.campaign.toLowerCase().includes(clientSearchTerm.toLowerCase()) ||
                    el.campaignId.toString().startsWith(clientSearchTerm)
                  : el.campaign.toLowerCase().includes(''),
              );
  }, [
    dashType,
    availableCampaigns,
    clientFilterList,
    startDateFilter,
    endDateFilter,
    excludeAlwaysOn,
    order,
    clientSearchTerm,
  ]);

  const navigationCampaignList = useMemo(() => {
    return permanentCampaignList !== null
      ? permanentCampaignList
          ?.filter((element) =>
            clientFilterList.length > 0
              ? clientFilterList.some(
                  (element2) => element2?.code === element?.ClientCode && element2?.country === element?.ClientCountry,
                )
              : !clientFilterList.some(
                  (element2) => element2?.code === element?.ClientCode && element2?.country === element?.ClientCountry,
                ),
          )
          .filter((el) => {
            const startDate = new Date(el?.startDate as string);
            const endDate = new Date(el?.startDate as string);
            const startDateFilterDate = new Date(startDateFilter);
            const endDateFilterDate = new Date(endDateFilter);
            const dashboardType = el?.dashboardType as Array<DashboardTypes>;

            // console.log("This is the campaign list", dashboardType)

            return startDate >= startDateFilterDate && endDate <= endDateFilterDate;
          })
          .filter((el) => {
            if (excludeAlwaysOn) {
              // return campaigns whose difference between start and end date is less than 180 days
              const startDate = new Date(el?.startDate as string);
              const endDate = new Date(el?.endDate as string);
              const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              return diffDays < 180;
            } else {
              return el;
            }
          })
          .sort((a, b) => {
            if (a?.startDate && b?.startDate) {
              if (order === 'asc') {
                return new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
              } else {
                return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
              }
            } else {
              return 0;
            }
          })
      : [];
  }, [permanentCampaignList, clientFilterList, startDateFilter, endDateFilter, excludeAlwaysOn, order]);
  const [campaignPeriodDeleted, setCampaignPeriodDeleted] = useState<boolean>(false);

  useEffect(() => {
    if (dashType === DashboardTypes.TV || dashType === DashboardTypes.RADIO) {
      setCampaignPeriodDeleted(true);
    } else {
      setCampaignPeriodDeleted(false); // Resetiraj kada nije TV ili RADIO
    }
  }, [dashType]);

  // 3. Pojednostavi postojeći useEffect koji briše campaignPeriodID
  useEffect(() => {
    if (campaignPeriodDeleted) {
      deleteCampaignPeriod();
      setCampaignPeriodDeleted(false); // Resetiraj nakon brisanja
    }
  }, [campaignPeriodDeleted, deleteCampaignPeriod]);

  const checkCampaignPeriods = useCallback(
    (el: ACdetails) => {
      if (dashType === DashboardTypes.TV || dashType === DashboardTypes.RADIO) {
        // if the dashType is TV or RADIO, return the element as it is
        return el;
      }
      if (el?.campaignPeriods && el?.campaignPeriods.length > 0) {
        const findCustomReportID = el.campaignPeriods.find((el) => el?.CustomReportID === Number(campaignPeriod));
        const updatedEL = findCustomReportID
          ? {
              ...el,
              campaignPeriods: el.campaignPeriods?.map((elPeriod) => {
                return {
                  ...elPeriod,
                  isActive: elPeriod?.CustomReportID === Number(campaignPeriod),
                };
              }),
              campaignId: findCustomReportID?.CustomReportID,
              parentReference: /* el.parentReference ?? */ el.campaignId,
              subcampaign: findCustomReportID.subcampaign,
            }
          : {
              ...el,
              campaignPeriods: el.campaignPeriods?.map((elPeriod) => {
                return {
                  ...elPeriod,
                  isActive: elPeriod?.CustomReportID === Number(campaignPeriod),
                };
              }),
            };

        return updatedEL;
      } else {
        return el;
      }
    },
    [dashType, campaignPeriod],
  );

  const checkChildAndDash = useCallback(
    (el: ACdetails) => {
      //checking if dashboard is different from flowchart and if there are childCampaigns
      if (dashType === DashboardTypes.FLOWCHART) {
        return el;
      } else {
        if (el?.childCampaigns && el?.childCampaigns.length > 0) {
          const indexOfChildCampaign = el.childCampaigns.findIndex((el) => el?.campaignId === Number(childCamp));

          if (indexOfChildCampaign === -1) {
            return checkCampaignPeriods(el) as ACdetails;
          } else {
            const returnwithParentRef = {
              ...el.childCampaigns[indexOfChildCampaign],
              parentReference: el.campaignId,
            };
            return checkCampaignPeriods(returnwithParentRef) as ACdetails;
          }
        } else {
          return checkCampaignPeriods(el) as ACdetails;
        }
      }
    },
    [dashType, childCamp, checkCampaignPeriods],
  );

  const activeCampaignNoUndefined = useMemo(() => {
    return campaignId === 'none'
      ? 'NOT_SELECTED'
      : availableCampaigns?.some((el) => el?.campaignId === Number(campaignId))
        ? checkChildAndDash(availableCampaigns?.find((el) => el?.campaignId === Number(campaignId)) as ACdetails)
        : undefined;
  }, [campaignId, availableCampaigns, dashType, childCamp, campaignPeriod]);

  const activeCampaign = activeCampaignNoUndefined === 'NOT_SELECTED' ? undefined : activeCampaignNoUndefined;
  const [activeSubCampaign, subCampaignList] = useActiveSubCampaign(dashType, activeCampaign);
  useEffect(() => {
    console.log('ActiveCampaign', activeCampaign);
    // iz nekog jebenog razloga ovo ne radi kak spada
  }, [activeCampaign]);

  // Auto-select the first published child + period for unauthorized users, so they never
  // land on an empty dashboard. Authorized users navigate freely.
  useEffect(() => {
    if (
      activeCampaign === undefined ||
      activeCampaign.authorized === true ||
      dashType === null ||
      dashType === DashboardTypes.TV ||
      dashType === DashboardTypes.RADIO ||
      campaignPeriod !== 'none'
    ) {
      return;
    }

    const effectiveDash = dashType === DashboardTypes.INSOURCE_DATA ? DashboardTypes.DIGITAL : dashType;

    type ACdetailsDefined = Exclude<ACdetails, undefined>;

    const isDirectlyPublished = (campaign: ACdetailsDefined): boolean => {
      const directKeys = Object.keys(campaign.subcampaign ?? {}).filter((k) => k !== '-1');
      if (directKeys.length > 0) {
        return directKeys.some((k) => (campaign.subcampaign as any)[k]?.published?.[effectiveDash] === true);
      }
      // Prefer rawPublished (added by CampaignContext on child campaigns with periods) to avoid
      // reading a value inflated by period propagation. Fall back to published when rawPublished
      // is absent (e.g. umbrella campaigns, which are never inflated from their own periods).
      const minusOne = campaign.subcampaign?.[-1] as any;
      return (minusOne?.rawPublished ?? minusOne?.published)?.[effectiveDash] === true;
    };

    const firstPublishedPeriod = (campaign: ACdetailsDefined) =>
      campaign.campaignPeriods?.find((p) => (p?.subcampaign[-1]?.published as any)?.[effectiveDash] === true);

    if (childCamp === 'none' && (activeCampaign.childCampaigns?.length ?? 0) > 0) {
      // Case 1: Umbrella selected with no child.
      // Skip if the umbrella itself is directly published — it has content to show.
      if (isDirectlyPublished(activeCampaign)) return;

      // Find first child that has a published period or is directly published,
      // then navigate to it (and its first published period if any).
      const targetChild = activeCampaign.childCampaigns?.find(
        (child) => firstPublishedPeriod(child as ACdetailsDefined) !== undefined || isDirectlyPublished(child as ACdetailsDefined),
      ) as ACdetailsDefined | undefined;

      if (targetChild) {
        const period = firstPublishedPeriod(targetChild);
        // Set both child and period atomically in one setSearchParams call to avoid
        // the second setter overwriting the first (each hook reads a stale URL snapshot).
        setSearchParams((prev) => {
          const next = new URLSearchParams(prev.toString());
          next.set('childCampaignID', targetChild.campaignId.toString());
          next.delete('subcampaignID');
          if (period) {
            next.set('campaignPeriodID', period.CustomReportID!.toString());
          }
          return next;
        });
      }
      return;
    }

    if (childCamp !== 'none' && (activeCampaign.campaignPeriods?.length ?? 0) > 0 && !isDirectlyPublished(activeCampaign)) {
      // Case 2: Child selected, not directly published — jump to its first published period.
      const period = firstPublishedPeriod(activeCampaign);
      if (period) {
        setCampaignPeriod(period.CustomReportID!.toString());
      }
    }
  }, [activeCampaign, dashType, childCamp, campaignPeriod]);

  const uniqueFilteredPermanentCampaignList = useCallback(() => {
    const filteredPermanentCampaignList = permanentCampaignList
      ? permanentCampaignList.flatMap((el) => {
          if (el) {
            if (el.ClientCode !== undefined && el.ClientCountry !== undefined && el.ClientCountry in countryEnum) {
              return { country: el.ClientCountry, client: el.ClientCode } as client;
            }
          }
          return [];
        })
      : [];

    return filteredPermanentCampaignList.reduce((acc, current) => {
      const x = acc.find((item) => item.country === current.country && item.client === current.client);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, [] as client[]);
  }, [permanentCampaignList]);

  useEffect(() => {
    if (permanentCampaignList && permanentCampaignList?.length > 0) {
      const reducedList = [
        ...new Map(
          permanentCampaignList?.map((v) => [JSON.stringify([v?.ClientCode, v?.ClientCountry, v?.ClientName]), v]),
        ).values(),
      ];

      setReducedClientList(reducedList);
    }
  }, [permanentCampaignList]);
  // useEffect(() => {
  //   console.log("CAMPAIGN LIST", campaignList)
  // }, [campaignList])

  const [kk, setKK] = useState<client[]>([]);
  useEffect(() => {
    const listofUniques = uniqueFilteredPermanentCampaignList();
    setKK(listofUniques);
  }, [permanentCampaignList, uniqueFilteredPermanentCampaignList]);

  const [a] = usePrepKPIQuery({
    clientCodes: kk,
  });

  useEffect(() => {
    if (a) {
      // console.log('queryKPI', a);
      setOverflowKPIquery(a);
    }
  }, [a]);

  // THIS IS FOR FILTERING DATA FROM THE QUERY
  const filteredPortalData = useMemo(() => {
    return fetchedPortalData
      .filter((element) =>
        clientFilterList.length > 0
          ? clientFilterList.some(
              (element2) => element2?.code === element?.client_code && element2?.country === element?.country,
            )
          : !clientFilterList.some(
              (element2) => element2?.code === element?.client_code && element2?.country === element?.country,
            ),
      )
      .filter((el) => {
        const startDate = new Date(el?.start_Date as string);
        const endDate = new Date(el?.end_Date as string);
        const startDateFilterDate = new Date(startDateFilter);
        const endDateFilterDate = new Date(endDateFilter);
        // TODO HERE THE END AND START DATE ARE MAKING THE CAMPAIGNS NOT WORKING AS EXPECTED
        return startDate >= startDateFilterDate && endDate <= endDateFilterDate;
      })
      .filter((el) => {
        if (excludeAlwaysOn) {
          // return campaigns whose difference between start and end date is less than 180 days
          const startDate = new Date(el?.start_Date as string);
          const endDate = new Date(el?.end_Date as string);
          const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          return diffDays < 180;
        } else {
          return el;
        }
      });
  }, [fetchedPortalData, clientFilterList, startDateFilter, endDateFilter, excludeAlwaysOn]);
  // **************** PREP DATA FOR PORTAL KPI START *************/
  const numberOfCampaigns = useMemo(() => campaignList?.length as number, [campaignList]);

  // Create a map of campaign_id to actual_cost sum
  const actualCostMap = useMemo(() => {
    return fetchedPortalData.reduce(
      (acc, fetEl) => {
        const startDate = new Date(fetEl?.start_Date as string);
        const endDate = new Date(fetEl?.end_Date as string);
        const startDateFilterDate = new Date(startDateFilter);
        const endDateFilterDate = new Date(endDateFilter);

        if (startDate >= startDateFilterDate && endDate <= endDateFilterDate) {
          acc[fetEl.campaign_id] = (acc[fetEl.campaign_id] || 0) + (fetEl['actual_cost'] || 0);
        }

        return acc;
      },
      {} as Record<string, number>,
    );
  }, [fetchedPortalData, startDateFilter, endDateFilter]);

  // Map over campaignList and get the actual_cost sum for each campaign from the map
  const campaignsThatRanInSelectedPeriod = useMemo(() => {
    return campaignList?.flatMap((el) => {
      // Get the actual cost for the parent campaign
      const parentCost = actualCostMap[el?.campaignId] || 0;
      // Get the actual cost for all child campaigns, if any
      const childCosts = el?.childCampaigns?.map((child) => actualCostMap[child?.campaignId as number] || 0) || [];
      // Combine the parent cost and child costs
      return [parentCost, ...childCosts];
    });
  }, [campaignList, actualCostMap]);

  // Sum all the items in the array campaignsThatRanInSelectedPeriod
  const actualBudget = useMemo(() => {
    return campaignsThatRanInSelectedPeriod?.reduce((a, b) => a + b, 0) as number;
  }, [campaignsThatRanInSelectedPeriod]);
  // console.log('actualBudget', actualBudget, campaignsThatRanInSelectedPeriod, fetchedPortalData);
  // Filter campaignList for campaigns with status 'PUBLISHED', then map over it and get the actual_cost sum for each campaign from the map
  const campaignsThatRanInSelectedPeriodPublished = campaignList?.flatMap((el) => {
    // Check if the parent campaign is published
    const parentCost = el.status === 'CAMPAIGN_PUBLISHED' ? actualCostMap[el?.campaignId] || 0 : 0;

    // Check if any child campaigns are published and include their costs
    const childCosts =
      el?.childCampaigns?.map((child) =>
        el.status === 'CAMPAIGN_PUBLISHED' ? actualCostMap[child?.campaignId as number] || 0 : 0,
      ) || [];

    // Combine the parent cost and child costs
    return [parentCost, ...childCosts];
  });
  // Sum all the items in the array campaignsThatRanInSelectedPeriod
  const actualBudgetPublished = campaignsThatRanInSelectedPeriodPublished?.reduce((a, b) => a + b, 0) as number;
  const currentYearBudget = campaignList?.reduce((a, b) => a + Number(b?.briefed_amount), 0);
  const recommendedYearBudget = campaignList?.reduce((a, b) => a + Number(b?.recommended_budget_ctc), 0);
  const approvedBudget = campaignList?.reduce((a, b) => a + Number(b?.approved_budget), 0);
  // **************** PREP DATA FOR PORTAL KPI END *************/

  const [, summaryPublishedOutputLocation] = useGetSummaryStatus(
    !activeCampaign?.authorized ? activeCampaign : undefined,
  );
  // console.log('summaryPublishedOutputLocation', summaryPublishedOutputLocation);

  const outputLocation =
    summaryPublishedOutputLocation && summaryPublishedOutputLocation.length > 0
      ? summaryPublishedOutputLocation.find((el: any) => el.position === 'Summary')?.outputlocation
      : undefined;
  const [campaignOverFlowdata, , , , ,] = useDataQuery({
    query: undefined,
    querySource: 'CAMPAIGN OVERFLOW KPI',
    publishedOutputLocation: outputLocation,
  });
  // console.log("campaignOverFlowdata", campaignOverFlowdata)
  const publishedSummaryData = (campaignOverFlowdata as Array<IData>) ?? [];

  // **************** PREP DATA FOR SUMMARY TAB START *************/

  const joinChildCampaigns = (campaign: ACdetails) => {
    const childCampaigns = campaign?.childCampaigns as Array<ACdetails>;
    const childCampaignsIds = childCampaigns.map((el) => el?.campaignId);
    const childCampaignsData = filteredPortalData.filter((el) => childCampaignsIds.includes(el.campaign_id));
    return childCampaignsData;
  };

  const filteredPerActiveCampaign = activeCampaign?.authorized
    ? activeCampaign?.childCampaigns
      ? joinChildCampaigns(activeCampaign)
      : filteredPortalData.filter((el) => el.campaign_id === activeCampaign?.campaignId)
    : publishedSummaryData;

  const campaignActualBudget = filteredPerActiveCampaign.reduce((a, b) => a + (b['actual_cost'] || 0), 0);
  const media_sourceArray1 = filteredPerActiveCampaign.map(({ campaign_id, country, year_week, ...rest }) => rest);
  const filteredPerActiveCampaign3: Record<string, mediaSourceData[]> = media_sourceArray1.reduce((acc, curr) => {
    const key = curr.media_source;
    const curGroup = acc[key as keyof typeof acc] ?? [];
    return { ...acc, [key]: [...curGroup, curr] };
  }, {});
  // console.log('costPerMedia', filteredPerActiveCampaign);
  const costPerMedia: mediaSourceData[] = Object.keys(filteredPerActiveCampaign3).map((key) => {
    return {
      media_source: key,
      actual_cost: filteredPerActiveCampaign3[key].reduce((acc, curr) => acc + curr.actual_cost, 0),
    };
  });
  const year_weekeArray1 = filteredPerActiveCampaign.map(({ campaign_id, country, media_source, ...rest }) => rest);
  const filteredYearWeekArray1: Record<string, yearWeekData[]> = year_weekeArray1.reduce((acc, curr) => {
    const key = curr.year_week;
    const curGroup = acc[key as keyof typeof acc] ?? [];
    return { ...acc, [key]: [...curGroup, curr] };
  }, {});
  const costPerWeek: yearWeekData[] = Object.keys(filteredYearWeekArray1).map((key) => {
    return {
      year_week: key,
      actual_cost: filteredYearWeekArray1[key].reduce((acc, curr) => acc + curr.actual_cost, 0),
    };
  });

  // **************** PREP DATA FOR SUMMARY TAB START *************/

  const filterCampaignsPerClientCode = (filterList: IFilter[]) => {
    setClientFilterList(filterList);
    /*   setCampaignList([]) */
    const filteredCampaignList = permanentCampaignList?.filter((element) =>
      filterList.length > 0
        ? filterList.some(
            (element2) => element2?.code === element?.ClientCode && element2?.country === element?.ClientCountry,
          )
        : !filterList.some(
            (element2) => element2?.code === element?.ClientCode && element2?.country === element?.ClientCountry,
          ),
    );
    setTimeout(() => {
      /*    setCampaignList(filteredCampaignList) */
    }, 500);
  };

  const updatePermanentCampaignList = (amount: string, campaignID: string) => {
    if (permanentCampaignList !== null) {
      const updatedCampaignList = permanentCampaignList?.map((el) => {
        if (el?.campaignId === Number(campaignID)) {
          return {
            ...el,
            budget: amount,
          };
        }
        return el;
      });

      setPermanentCampaignList(updatedCampaignList);
    }
  };

  // const handleUpdateCampaignList = () => {

  // }

  return (
    <CampaignContext.Provider
      value={{
        campaignList,
        activeCampaign,
        // setActiveCampaign,
        setDashType,
        dashType,
        TVStationSelector,
        setTVStationSelector,
        RadioStationSelector,
        setRadioStationSelector,
        clientFilterList,
        setClientFilterList,
        reducedClientList,
        filterCampaignsPerClientCode,
        actualBudget,
        numberOfCampaigns,
        campaignActualBudget,
        costPerMedia,
        costPerWeek,
        currentYearBudget,
        recommendedYearBudget,
        approvedBudget,
        startDateFilter,
        setStartDateFilter,
        endDateFilter,
        setEndDateFilter,
        order,
        setOrder,
        fetchedPortalData,
        permanentCampaignList,
        setPermanentCampaignList,
        navigationCampaignList,
        availableCampaigns,
        checkDashPublished,
        activeSubCampaign,
        subCampaignList,
        updatePermanentCampaignList,
        actualBudgetPublished,
        /*         handlePublishSummary,
                campaignOverFlowqueryStatus, */
        overflowKPIquery,
        overFlowqueryStatus,
        setOverflowKPIquery,
        setClientSearchTerm,
        excludeAlwaysOn,
        setExcludeAlwaysOn,
        canDoInsourceAndOnInsourcePortal,
        childCampaignIndex,
        setChildCampaignIndex,
        customReportsList,
        setCustomReportsList,
        clientSearchTerm,
      }}
    >
      {props.children}
    </CampaignContext.Provider>
  );
};

export const useCampaignContext = () => {
  const context = useContext(CampaignContext);
  if (context === undefined) {
    throw new Error('context needs to be provided in campaign context');
  }
  return context;
};
